import { render } from "./GalleryControls.vue?vue&type=template&id=0e847162&scoped=true"
import script from "./GalleryControls.vue?vue&type=script&lang=js"
export * from "./GalleryControls.vue?vue&type=script&lang=js"

import "./GalleryControls.vue?vue&type=style&index=0&id=0e847162&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e847162"],['__file',"src/scripts/sections/modules/gallery/GalleryControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e847162"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e847162', __exports__)) {
    api.reload('0e847162', __exports__)
  }
  
  module.hot.accept("./GalleryControls.vue?vue&type=template&id=0e847162&scoped=true", () => {
    api.rerender('0e847162', render)
  })

}


export default __exports__